import { render, staticRenderFns } from "./MyGroupPageStats.vue?vue&type=template&id=63a51260&"
import script from "./MyGroupPageStats.vue?vue&type=script&lang=js&"
export * from "./MyGroupPageStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports